import { render, staticRenderFns } from "./ContactSlot.vue?vue&type=template&id=5cbf848d&scoped=true"
import script from "./ContactSlot.vue?vue&type=script&lang=ts"
export * from "./ContactSlot.vue?vue&type=script&lang=ts"
import style0 from "./ContactSlot.vue?vue&type=style&index=0&id=5cbf848d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbf848d",
  null
  
)

export default component.exports